/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_ORDERS = 'REQUEST_ORDERS';
export const REQUEST_ORDERS_SUCCESS = 'REQUEST_ORDERS_SUCCESS';
export const REQUEST_ORDERS_FAILURE = 'REQUEST_ORDERS_FAILURE';

export const REQUEST_ORDER = 'REQUEST_ORDER';
export const REQUEST_ORDER_SUCCESS = 'REQUEST_ORDER_SUCCESS';
export const REQUEST_ORDER_FAILURE = 'REQUEST_ORDER_FAILURE';

export const REQUEST_ADD_ORDER = 'REQUEST_ADD_ORDER';
export const REQUEST_ADD_ORDER_SUCCESS = 'REQUEST_ADD_ORDER_SUCCESS';
export const REQUEST_ADD_ORDER_FAILURE = 'REQUEST_ADD_ORDER_FAILURE';

export const REQUEST_UPDATE_ORDER = 'REQUEST_UPDATE_ORDER';
export const REQUEST_UPDATE_ORDER_SUCCESS = 'REQUEST_UPDATE_ORDER_SUCCESS';
export const REQUEST_UPDATE_ORDER_FAILURE = 'REQUEST_UPDATE_ORDER_FAILURE';

export const REQUEST_DELETE_ORDER = 'REQUEST_DELETE_ORDER';
export const REQUEST_DELETE_ORDER_SUCCESS = 'REQUEST_DELETE_ORDER_SUCCESS';
export const REQUEST_DELETE_ORDER_FAILURE = 'REQUEST_DELETE_ORDER_FAILURE';

export const REQUEST_POSTING_ORDER = 'REQUEST_POSTING_ORDER';
export const REQUEST_POSTING_ORDER_SUCCESS = 'REQUEST_POSTING_ORDER_SUCCESS';
export const REQUEST_POSTING_ORDER_FAILURE = 'REQUEST_POSTING_ORDER_FAILURE';

export const REQUEST_AUTONUMBER_ORDER = 'REQUEST_AUTONUMBER_ORDER';
export const REQUEST_AUTONUMBER_ORDER_SUCCESS = 'REQUEST_AUTONUMBER_ORDER_SUCCESS';
export const REQUEST_AUTONUMBER_ORDER_FAILURE = 'REQUEST_AUTONUMBER_ORDER_FAILURE';


export const REQUEST_ORDERS_POSTED = 'REQUEST_ORDERS_POSTED';
export const REQUEST_ORDERS_POSTED_SUCCESS = 'REQUEST_ORDERS_POSTED_SUCCESS';
export const REQUEST_ORDERS_POSTED_FAILURE = 'REQUEST_ORDERS_POSTED_FAILURE';

export const REQUEST_ORDERS_NOTPAY = 'REQUEST_ORDERS_NOTPAY';
export const REQUEST_ORDERS_NOTPAY_SUCCESS = 'REQUEST_ORDERS_NOTPAY_SUCCESS';
export const REQUEST_ORDERS_NOTPAY_FAILURE = 'REQUEST_ORDERS_NOTPAY_FAILURE';

export const REQUEST_PRINT_LABEL = 'REQUEST_PRINT_LABEL';
export const REQUEST_PRINT_LABEL_SUCCESS = 'REQUEST_PRINT_LABEL_SUCCESS';
export const REQUEST_PRINT_LABEL_FAILURE = 'REQUEST_PRINT_LABEL_FAILURE';

export const REQUEST_PRINT_CONSIGMENT = 'REQUEST_PRINT_CONSIGMENT';
export const REQUEST_PRINT_CONSIGMENT_SUCCESS = 'REQUEST_PRINT_CONSIGMENT_SUCCESS';
export const REQUEST_PRINT_CONSIGMENT_FAILURE = 'REQUEST_PRINT_CONSIGMENT_FAILURE';

export const REQUEST_ORDERS_PRINT = 'REQUEST_ORDERS_PRINT';
export const REQUEST_ORDERS_PRINT_FAILURE = 'REQUEST_ORDERS_PRINT_FAILURE';
export const REQUEST_ORDERS_PRINT_SUCCESS = 'REQUEST_ORDERS_PRINT_SUCCESS';

export const REQUEST_ORDER_HISTORY = 'REQUEST_ORDER_HISTORY';
export const REQUEST_ORDER_HISTORY_SUCCESS = 'REQUEST_ORDER_HISTORY_SUCCESS';
export const REQUEST_ORDER_HISTORY_FAILURE = 'REQUEST_ORDER_HISTORY_FAILURE';

export const REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY = 'REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY';
export const REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY_SUCCESS = 'REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY_SUCCESS';
export const REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY_FAILURE = 'REQUEST_ORDERS_PAYMENT_TYPES_NOT_PAY_FAILURE';
